/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CakeSlice = [
  ["path", { d: "M16 13H3" }],
  ["path", { d: "M16 17H3" }],
  [
    "path",
    {
      d: "m7.2 7.9-3.388 2.5A2 2 0 0 0 3 12.01V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-8.654c0-2-2.44-6.026-6.44-8.026a1 1 0 0 0-1.082.057L10.4 5.6"
    }
  ],
  ["circle", { cx: "9", cy: "7", r: "2" }]
];

export { CakeSlice as default };
//# sourceMappingURL=cake-slice.js.map
